import './index.less';

import { LoadingOutlined } from '@ant-design/icons';
import { Table } from 'antd';
import { ColumnsType } from 'antd/es/table';
import { TableProps } from 'antd/es/table';

import empty from '@/assets/empty.svg';
import Pagination from '@/components/Pagination';
import {
  IPage,
  IPageAction,
} from '@/components/SearchTablePage/utils/commonInterface';
import { useI18nContext } from '@/i18n/I18n';

const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;

export const PAGESIZE = 10;
export interface BybitTableProps<RecordType> {
  className?: string;
  columns: ColumnsType<RecordType>;
  dataSource: RecordType[];
  rowKey: string | ((record: RecordType) => string);
  loading?: boolean;
  defaultPageSize?: number;
  paginationRef?: any;
  tableProps?: TableProps<RecordType>;
  pageParams?: IPage;
  footer?: () => JSX.Element | null;
  turnPages?: (size: number | IPageAction) => void;
  title?: () => JSX.Element;
}

function BybitTable<RecordType extends object = any>(
  opt: BybitTableProps<RecordType>,
): JSX.Element {
  const {
    rowKey,
    columns,
    tableProps = {},
    dataSource,
    defaultPageSize = PAGESIZE,
    // eslint-disable-next-line @typescript-eslint/naming-convention
    loading = false,
    paginationRef,
    pageParams = {},
    title,
    turnPages,
    footer,
  } = opt;
  const [$t, lang] = useI18nContext();
  const defaultEmpty = () => (
    <div className="bybit-empty">
      <img src={empty} alt="empty" />
      <div className="bybit-empty-description">{$t('table.empty')}</div>
    </div>
  );
  const getFooter = () => {
    if (footer) {
      return footer();
    }
    return (
      <Pagination
        ref={paginationRef}
        pageParams={pageParams}
        defaultPageSize={defaultPageSize}
        onPreClick={turnPages}
        onNextClick={turnPages}
      />
    );
  };

  tableProps.className =
    lang === 'ar-SA'
      ? 'rotate-table ' + tableProps.className
      : tableProps.className;

  const getTableProps = () => {
    const defaultTableConf = {
      title,
      dataSource,
      columns,
      loading,
      rowKey,
      scroll: { x: 'max-content' },
      locale: { emptyText: defaultEmpty() },
      ...tableProps,
      className: tableProps.className
        ? `bybit-table ${tableProps.className} ${opt.className}`
        : `bybit-table ${opt.className}`,
    };
    if (!footer || (footer && footer())) {
      defaultTableConf.footer = getFooter;
    }
    // 有翻页器就有线 没有翻页器就没有线
    if (!defaultTableConf.footer) {
      defaultTableConf.className += ' bybit-table-no-line';
    }
    return defaultTableConf;
  };

  return (
    <Table<RecordType>
      pagination={false}
      {...getTableProps()}
      loading={{
        spinning: loading,
        indicator: antIcon,
      }}
    />
  );
}

export default BybitTable;
